import { render, staticRenderFns } from "./ProductListMobile.vue?vue&type=template&id=50322aab&scoped=true"
import script from "./ProductListMobile.vue?vue&type=script&lang=js"
export * from "./ProductListMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductListMobile.vue?vue&type=style&index=0&id=50322aab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50322aab",
  null
  
)

export default component.exports